import axios from "@/axios";
import { ClientsResponse } from "@/commons/types";
import { AxiosResponse } from "axios";

export function getClients(): Promise<AxiosResponse<ClientsResponse>> {
  return axios.get<ClientsResponse>(`/clients/`);
}
